/*eslint-disable*/

const sortPagesByUrl = (pages, mainUrl) => {
    return pages.filter(({ keyword }) => {
      const keys = keyword.split('/');

      if (!mainUrl) {
        return keys.length === 1;
      }

      return keys.includes(mainUrl);
    });
};

export default sortPagesByUrl;


// WEBPACK FOOTER //
// ./src/shared/utils/helpers/filterPagesByUrl.js